import React from "react";
import {
    Link,
    Stack,
} from "@mui/material";
import {
    
    ViewModule,
    Edit,
} from "@mui/icons-material";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";
import { useHref } from "react-router";
import {StyledNavLink} from "../../../../share/components/styled/Table";
import {useGetCuttingQuery} from "../../../apis/Cutting.api.ts";
import {PrimaryCutting} from "../../../types/models/Cutting.ts";
import {cuttingStateEditCheck, shippingStateCheck} from "../../../stateChecks.ts";

const ShipmentListItemTools = ({data, onClickUrl, onEditUrl, onDelete}) => {

    const session = useStateSession()

    const { data: cutting } = useGetCuttingQuery(PrimaryCutting.fromId(data?.cuttingId), {skip: !data?.cuttingId})

    const onClickHref = useHref(onClickUrl);
    const onEditHref = useHref(onEditUrl);

    const showEdit = (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/Shipments/update/view'
        ) ||
false)
        && cuttingStateEditCheck(cutting?.state)
        && shippingStateCheck(session, data?.state)
    
    
    
    return (
        <Stack direction="row" spacing={1} sx={{ justifyContent: "center" }}>
            <Link size="small" component={StyledNavLink} arial-label={t`View`}
                  to={ onClickHref }
                  viewTransition={true}
            >
                <ViewModule />
            </Link>
            { showEdit &&
                <Link size="small" component={StyledNavLink} arial-label={t`Edit`}
                      to={ onEditHref }
                      viewTransition={true}
                >
                    <Edit />
                </Link>
            }
            
        </Stack>
    )
}

export default ShipmentListItemTools;
